import { ContactDialog } from "@/lib/nemmp/base/contact/ContactDialog";
import { BuyerType } from "@/framework/billing/stripe";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import { useState } from "react";
import { countryLabel } from "./buyerCountryOptions";

type UnsupportedCountryNoticeProps = {
  buyerType: BuyerType;
  countryCode: string;
};

// Shown when we cannot yet sell to the selected buyer type / country pair.
// Instead of a dead end, the buyer can ask for that combination to be enabled.
export const UnsupportedCountryNotice = ({
  buyerType,
  countryCode,
}: UnsupportedCountryNoticeProps) => {
  const [contactOpen, setContactOpen] = useState(false);
  const buyerLabel =
    buyerType === "business" ? "Business" : "Private individual";

  return (
    <>
      <Alert
        severity="warning"
        // The action column must not shrink, otherwise the narrow topup form
        // squeezes the button and its label breaks into two lines.
        sx={{ mb: 2, "& .MuiAlert-action": { flexShrink: 0 } }}
        action={
          <Button
            color="inherit"
            size="small"
            onClick={() => setContactOpen(true)}
            sx={{ whiteSpace: "nowrap" }}
          >
            Contact me
          </Button>
        }
      >
        {buyerLabel} purchases from {countryLabel(countryCode)} are not
        supported yet. Get in touch and I will see what I can do.
      </Alert>

      <ContactDialog
        open={contactOpen}
        onClose={() => setContactOpen(false)}
        topic={`purchase from ${countryCode} (${buyerType})`}
        config={{
          intro: `Tell me a bit about yourself and I will check whether I can enable ${buyerLabel.toLowerCase()} purchases from ${countryLabel(countryCode)}.`,
        }}
      />
    </>
  );
};
